/**
 * Page columns. Create/edit forms and short detail views use the narrow one; detail views
 * with tables or side cards (product, order, quote) use the wide one. Applied to the page
 * root so the title and the cards share the same left edge and the whole page is centered.
 */
export const FORM_COLUMN = 'mx-auto w-full max-w-2xl';
export const WIDE_COLUMN = 'mx-auto w-full max-w-4xl';
